export const environment = {
    production: false,
    baseUrlAPI: 'https://myenergytest.novitech.sk/api/v1',
    // baseUrlAPI:"https://myenergy.novitech.sk/api/v1",
    baseUrlDataAPI: 'https://myenergytest.novitech.sk/data',
};
